import React from "react";
import "./Details.css";
import "./Help.css";
import { Link } from "react-router-dom";
import Navbar from "./navbar";

function Help() {
  const pageTitle = "Help";

  return (
    <div className="details-container-page help-page">
      <Navbar pageTitle={pageTitle} onToggleSidebar={true} />

      <div className="details-main">
        <div className="settings-grid">
          {/* LEFT COLUMN */}
          <div className="settings-column">
            {/* Intro card */}
            <section className="settings-card">
              <div className="settings-card-header">
                <h2 className="settings-card-title">
                  Welcome to the Table Mate Help Centre
                </h2>
              </div>

              <p className="help-intro">
                Here you can find answers to frequently asked questions, user
                guides, and support resources to help you make the most of
                Table Mate. Whether you&#39;re getting started or looking for
                advanced tips, we&#39;re here to assist you.
              </p>

              <ul className="help-list">
                <li>Step-by-step setup guides</li>
                <li>Troubleshooting tips for common issues</li>
                <li>Best practices for managing your restaurant</li>
              </ul>
            </section>

            {/* User guide card */}
            <section className="settings-card">
              <div className="settings-card-header">
                <h2 className="settings-card-title">User Documentation</h2>
              </div>

              <p className="help-text">
                Access the full user guide, including screenshots and
                walkthroughs for each feature.
              </p>

              <a
                href="https://support.tablemate.net/"
                target="_blank"
                rel="noreferrer"
                className="tm-btn tm-btn-primary tm-btn-full"
              >
                Open Table Mate User Guide
              </a>
            </section>
          </div>

          {/* RIGHT COLUMN */}
          <div className="settings-column">
            {/* Contact support card */}
            <section className="settings-card">
              <div className="settings-card-header">
                <h2 className="settings-card-title">Need Help from Support?</h2>
              </div>

              <p className="help-text">
                Can&#39;t find what you&#39;re looking for in the guide? Reach
                out to the Table Mate support team.
              </p>

              <a
                href="https://tablemate.net/#contactus"
                target="_blank"
                rel="noreferrer"
                className="tm-btn tm-btn-primary tm-btn-full"
              >
                Contact Support
              </a>
            </section>

            {/* Licensing / website card */}
            <section className="settings-card">
              <div className="settings-card-header">
                <h2 className="settings-card-title">More Resources</h2>
              </div>

              <div className="help-links-column">
                <Link
                  to="/license"
                  className="tm-btn tm-btn-light tm-btn-full"
                >
                  View Licensing Information
                </Link>

                <a
                  href="https://tablemate.net"
                  target="_blank"
                  rel="noreferrer"
                  className="tm-btn tm-btn-light tm-btn-full"
                >
                  Visit Official Website
                </a>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help;
